import request from '@/utils/request'

//获取账户信息
export function getAccountInfo(query) {
  return request({
    url: '/center',
    method: 'post',
    params: query,
  })
}



// WEBPACK FOOTER //
// ./src/api/center/index.js